export default "__VITE_ASSET__BjXgCku___"